import {
  Button,
  Header,
} from '@cloudscape-design/components';
import {
  collection,
  getFirestore,
  orderBy,
  where,
} from 'firebase/firestore';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { OrderList } from '../../components/Orders';
import useCustomInfiniteQuery from '../../hooks/use-customInfiniteQuery';

export default function OrderListPage({ isInternal = false }) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const ordersQueryParams = useMemo(() => [
    collection(getFirestore(), 'orders'),
    where('isInternal', '==', isInternal),
    orderBy('orderDate', 'desc'),
  ], [isInternal]);

  const {
    CustomPagination,
    pageData,
    isFetchingNextPage,
  } = useCustomInfiniteQuery({
    queryKey: isInternal ? 'getInternalOrdersData' : 'getCustomerOrdersData',
    queryParams: ordersQueryParams,
    pageSize: 25,
  });

  return (
    <OrderList
      header={(
        <Header
          variant="awsui-h1-sticky"
          actions={(
            <Button onClick={() => { navigate(`/orders/create?${searchParams.toString()}`); }}>
              {isInternal ? 'Create Internal Order' : 'Create Customer Order'}
            </Button>
          )}
        >
          {isInternal ? 'Internal Orders' : 'Customer Orders'}
        </Header>
      )}
      variant="full-page"
      orders={pageData}
      isLoading={isFetchingNextPage}
      Pagination={<CustomPagination />}
    />
  );
}
OrderListPage.propTypes = {
  isInternal: PropTypes.bool,
};
